import type { ReactNode } from "react";

export function FormFieldGroup({
  label,
  error,
  hint,
  children,
}: {
  label: string;
  error?: string;
  hint?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div>
      <div className="mb-1 flex items-baseline justify-between gap-2">
        <label className="text-[11px] font-semibold text-foreground/75">
          {label}
        </label>
        {hint}
      </div>
      {children}
      {error && (
        <p className="mt-1 text-[11px] font-medium text-destructive">{error}</p>
      )}
    </div>
  );
}
